var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24883_206515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8081 10.2312C19.8081 9.55141 19.753 8.86797 19.6354 8.19922H10.2031V12.05H15.6046C15.3804 13.292 14.6602 14.3907 13.6057 15.0888V17.5874H16.8282C18.7205 15.8457 19.8081 13.2736 19.8081 10.2312Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2019 20.0017C12.8989 20.0017 15.1734 19.1162 16.8306 17.5876L13.6081 15.089C12.7115 15.699 11.5541 16.0444 10.2056 16.0444C7.59669 16.0444 5.38468 14.2843 4.591 11.918H1.26562V14.4938C2.96322 17.8706 6.42087 20.0017 10.2019 20.0017Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58857 11.9163C4.16969 10.6743 4.16969 9.32947 4.58857 8.0875V5.51172H1.26688C-0.151459 8.33737 -0.151459 11.6664 1.26688 14.4921L4.58857 11.9163Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2019 3.95805C11.6276 3.936 13.0055 4.47247 14.038 5.45722L16.893 2.60218C15.0852 0.904587 12.6858 -0.0287217 10.2019 0.000673888C6.42087 0.000673888 2.96322 2.13185 1.26562 5.51234L4.58732 8.08813C5.37733 5.71811 7.59302 3.95805 10.2019 3.95805Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24883_206515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogle);
export default __webpack_public_path__ + "static/media/ic_google.987255692b523758f876567fa9555990.svg";
export { ForwardRef as ReactComponent };